import { CompanySearchResultItem } from 'store/modules/search/searchService/types';

export const companyActionURL = (company: Pick<CompanySearchResultItem, 'uuid'>) =>
  `/companies/${company.uuid}`;
